RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.SocialHandle = Marionette.ItemView.extend({
        template: '#adminCompanySocialHandleTemplate',
        tagName: 'li',
        className: 'list-group-item',

        modelEvents: {
            'change:is_primary': 'render'
        },

        ui: {
            setPrimaryBtn: '.x-set-primary',
            deleteBtn: '.x-delete',
            deleteModalBtn: '.x-delete-modal',
            finderDetailsBtn: '.x-finder-details'
        },

        events: {
            'click @ui.setPrimaryBtn': 'setPrimary',
            'click @ui.deleteBtn': 'deleteHandle',
            'click @ui.deleteModalBtn': 'showDeleteModal',
            'click @ui.finderDetailsBtn': 'showFinderDetails'
        },

        templateHelpers: function () {
            const me = this;
            const model = me.model.toJSON();

            const defaults = {
                handle: '',
                is_primary: false,
                handleCount: me.model.collection.length,
                native_id: model.handle
            };

            model.data = _.extend(model, model.finderPicked, model.data);

            return _.defaults(model, defaults);
        },

        setPrimary: function () {
            const me = this;
            me.model.set({
                is_primary: true
            });
        },

        deleteHandle: function () {
            const me = this;
            me.model.trigger('destroy', me.model, me.model.collection);
        },

        showDeleteModal: function () {
            const me = this;
            App.socialHandlesModal.$el.modal('hide');
            App.companyPrimaryHandleDeleteModal.show(new views.PrimaryHandleDeleteModal({
                model: me.model
            }));
        },

        showFinderDetails: function () {
            const me = this;
            const picked = me.model.get('finderPicked');
            App.handleDiscoveryModal.show(new views.HandlePickerItem({
                template: '#adminCompanyPrimaryHandleDiscoveryTemplate',
                tagName: 'div',
                className: 'modal-dialog',
                model: new RivalIQ.models.SocialHandle(picked)
            }));
        }
    });
});
